import React, { useState } from "react";
import { Badge, Button, Card, Flex, Text } from "@radix-ui/themes";

import { PermissionAlertDialog } from "components";
import { useGetBrazeStatus } from "hooks";
import { BrazeMark } from "./BrazeMark";
import { BrazeSetupDialog } from "./BrazeSetupPage";

export function BrowseBrazeCard({ userProfile }) {
  const { data } = useGetBrazeStatus(userProfile?.organisation_id);
  const isActive = data?.data?.is_active === true;
  const [setupOpen, setSetupOpen] = useState(false);
  const [permissionOpen, setPermissionOpen] = useState(false);

  return (
    <>
      <Card
        style={{
          display: "flex",
          width: "100%",
          minWidth: 0,
          padding: "var(--space-4)",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "var(--space-3)",
          overflow: "hidden",
        }}
      >
        <Flex align="center" gap="4" style={{ minWidth: 0, flex: "1 1 auto" }}>
          <BrazeMark />
          <Flex direction="column" justify="center" align="start" gap="1" style={{ minWidth: 0 }}>
            <Text size="4" weight="medium" truncate>Braze</Text>
            <Text size="1" color="gray" truncate>Customer engagement & CRM</Text>
          </Flex>
        </Flex>
        {isActive ? (
          <Badge size="1" variant="soft" color="green" style={{ flexShrink: 0 }}>Connected</Badge>
        ) : (
          <Button
            onClick={() => userProfile?.user_role === "Owner" ? setSetupOpen(true) : setPermissionOpen(true)}
            size="2"
            variant="soft"
            color="gray"
            style={{ flexShrink: 0 }}
          >
            Connect
          </Button>
        )}
      </Card>
      {setupOpen && <BrazeSetupDialog isOpen={setupOpen} onOpenChange={setSetupOpen} />}
      <PermissionAlertDialog
        isOpen={permissionOpen}
        onOpenChange={setPermissionOpen}
        message="Only owners can perform this action"
      />
    </>
  );
}
